import React from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
  Form,
  UncontrolledAlert,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { AppDispatch } from "src";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { addUnitType } from "src/slices/UnitsTypes/thunk";
import useToast from "src/components/Common/toast";

const NormalValidation = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { show, ToastComponent } = useToast();
  const validation = useFormik({
    initialValues: {
      name: "",
      level: "",
      key: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Por favor, insira o nome"),
      level: Yup.string().required("Por favor, insira o nível"),
      key: Yup.string().required("Por favor, insira a chave"),
    }),
    onSubmit: async values => {
      await dispatch(addUnitType(values)).then(response => {
        if (
          typeof response.payload === "string" &&
          response.payload.includes("Request failed with")
        ) {
          show("Erro", "Erro ao criar tipo de orgão de estrutura");
        } else {
          show("Sucesso", "Tipo de orgão de estrutura criado com sucesso");
          validation.resetForm();
        }
      });
      validation.resetForm();
    },
  });

  return (
    <React.Fragment>
      {ToastComponent}
      <Col>
        <Card>
          <CardBody>
            <Form
              className="needs-validation"
              onSubmit={e => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="validationCustom01">Nome</Label>
                  <Input
                    name="name"
                    placeholder="Nome"
                    type="text"
                    className="form-control"
                    id="validationCustom01"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name && validation.errors.name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.name}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="validationCustom04">Chave</Label>
                  <Input
                    name="key"
                    placeholder="Chave"
                    type="text"
                    className="form-control"
                    id="validationCustom04"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.key || ""}
                    invalid={
                      validation.touched.key && validation.errors.key
                        ? true
                        : false
                    }
                  />
                  {validation.touched.key && validation.errors.key ? (
                    <FormFeedback type="invalid">
                      {validation.errors.key}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="validationCustom03">Nível</Label>
                  <Input
                    name="level"
                    placeholder="Nível"
                    type="select"
                    className="form-control"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.level || ""}
                    invalid={
                      validation.touched.level && validation.errors.level
                        ? true
                        : false
                    }
                  >
                    <option value="">Selecione</option>
                    <option value="1">Nivel 1</option>
                    <option value="2">Nivel 2</option>
                    <option value="3">Nivel 3</option>
                    <option value="4">Nivel 4</option>
                    <option value="5">Nivel 5</option>
                    <option value="6">Nivel 6</option>
                  </Input>
                  {validation.touched.level && validation.errors.level ? (
                    <FormFeedback type="invalid">
                      {validation.errors.level}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </Col>

              <Button color="primary" type="submit">
                Submiter
              </Button>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default NormalValidation;
